var exports = {
  "N1": "ChannelHeader.module__headerContainer___X3RWcT",
  "dL": "ChannelHeader.module__headerWrapper___X3RWcT",
  "Hv": "ChannelHeader.module__headerWrapperCallActive___X3RWcT",
  "hE": "ChannelHeader.module__headerContainerCallActive___X3RWcT",
  "Ud": "ChannelHeader.module__headerLeftSection___X3RWcT",
  "Gv": "ChannelHeader.module__backButton___X3RWcT",
  "wK": "ChannelHeader.module__backButtonDesktop___X3RWcT" + " " + "ChannelHeader.module__backButton___X3RWcT",
  "j2": "ChannelHeader.module__backIcon___X3RWcT",
  "Ir": "ChannelHeader.module__backIconBold___X3RWcT" + " " + "ChannelHeader.module__backIcon___X3RWcT",
  "CY": "ChannelHeader.module__leftContentContainer___X3RWcT",
  "Bn": "ChannelHeader.module__voiceCallHeaderSupplement___X3RWcT",
  "BN": "ChannelHeader.module__mobileButton___X3RWcT",
  "Vt": "ChannelHeader.module__desktopButton___X3RWcT" + " " + "ChannelHeader.module__mobileButton___X3RWcT",
  "R3": "ChannelHeader.module__avatarWrapper___X3RWcT",
  "ax": "ChannelHeader.module__groupDmHeaderTrigger___X3RWcT",
  "_D": "ChannelHeader.module__groupDmHeaderInner___X3RWcT",
  "ab": "ChannelHeader.module__groupDmEditIcon___X3RWcT",
  "HA": "ChannelHeader.module__channelName___X3RWcT",
  "$7": "ChannelHeader.module__groupDmChannelName___X3RWcT",
  "kf": "ChannelHeader.module__dmNameWrapper___X3RWcT",
  "a1": "ChannelHeader.module__userTag___X3RWcT",
  "p": "ChannelHeader.module__channelIcon___X3RWcT",
  "ml": "ChannelHeader.module__caretRight___X3RWcT",
  "Nj": "ChannelHeader.module__channelInfoContainer___X3RWcT",
  "u8": "ChannelHeader.module__followButton___X3RWcT",
  "B6": "ChannelHeader.module__topicDivider___X3RWcT",
  "zm": "ChannelHeader.module__topicContainer___X3RWcT",
  "yu": "ChannelHeader.module__topicButton___X3RWcT",
  "Am": "ChannelHeader.module__topicButtonOverflow___X3RWcT",
  "lY": "ChannelHeader.module__headerRightSection___X3RWcT",
  "P0": "ChannelHeader.module__messageSearchFocusWrapper___X3RWcT",
  "bS": "ChannelHeader.module__headerContainerThreadPanelOpen___X3RWcT",
  "gb": "ChannelHeader.module__iconButton___X3RWcT",
  "f5": "ChannelHeader.module__iconButtonDefault___X3RWcT" + " " + "ChannelHeader.module__iconButton___X3RWcT",
  "vR": "ChannelHeader.module__iconButtonSelected___X3RWcT" + " " + "ChannelHeader.module__iconButton___X3RWcT",
  "rB": "ChannelHeader.module__updateIconButton___X3RWcT" + " " + "ChannelHeader.module__iconButton___X3RWcT",
  "l_": "ChannelHeader.module__updateIcon___X3RWcT",
  "Do": "ChannelHeader.module__updateIconSpinning___X3RWcT" + " " + "ChannelHeader.module__updateIcon___X3RWcT",
  "bx": "ChannelHeader.module__updateIconSpin___X3RWcT",
  "IC": "ChannelHeader.module__iconButtonMobile___X3RWcT",
  "iA": "ChannelHeader.module__buttonIcon___X3RWcT",
  "qt": "ChannelHeader.module__buttonIconMobile___X3RWcT",
  "Dm": "ChannelHeader.module__iconButtonWrapper___X3RWcT",
  "W9": "ChannelHeader.module__unreadPinIndicator___X3RWcT",
};

module.exports = exports;
